import { initializeApp, type FirebaseOptions } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

import firebaseClientConfig from './firebase.config.json'

const app = initializeApp(firebaseClientConfig as FirebaseOptions)

export const db = getFirestore(app)
export const storage = getStorage(app)
export const auth = getAuth(app)
